import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchVodAvailability, deleteVodAvailability } from 'store/actions';

// Import translation
import { useTranslation } from 'react-i18next';

// Import columns
import { createColumns } from './vod_availability_columns';

// Import components
import { TableTemplate } from 'components/common/templates';

const VodAvailability = ({
	error,
	fetchVodAvailability,
	deleteVodAvailability,
	resources,
	match: {
		params: { id }
	}
}) => {
	const { t } = useTranslation();

	return (
		// Dispatch fetchVodAvailability, deleteVodAvailability action in vod_availability
		<TableTemplate
			itemId={id}
			error={error}
			type={`vod/${id}/availability`}
			typeText="availability"
			addLinkText={t('availability:buttons.add')}
			resources={resources}
			columns={createColumns}
			fetchResourcesAction={fetchVodAvailability}
			deleteItemAction={deleteVodAvailability}
			notificationDeleteSuccessTxt={t(
				'availability:notification.delete_success'
			)}
			notificationDeleteErrorTxt={t('availability:notification.delete_error')}
		></TableTemplate>
	);
};

VodAvailability.propTypes = {
	error: PropTypes.bool.isRequired,
	resources: PropTypes.object.isRequired,
	fetchVodAvailability: PropTypes.func.isRequired,
	deleteVodAvailability: PropTypes.func.isRequired,
	match: PropTypes.shape({
		params: PropTypes.shape({ id: PropTypes.string.isRequired })
	})
};

const mapStateToProps = ({ vod: { availability } }) => ({
	error: availability.table.error,
	resources: availability.table
});

export default compose(
	connect(mapStateToProps, { fetchVodAvailability, deleteVodAvailability }),
	withRouter
)(VodAvailability);
